/**
 * Open the QueVee chat with a first message — the command search's Ask AI row.
 *
 * Module scope, `action-runner.ts`' shape and for its reason: the chat surface
 * is mounted somewhere `App` does not thread props to, and the palette should
 * not be handed one either. Whatever renders the chat publishes an opener here
 * on mount and withdraws it on unmount; `App` reads it into the action context
 * behind the `agent` feature (brand + `feat:agent`).
 *
 * **No opener, no row.** Until a chat surface publishes one, Ask AI is absent
 * from the palette rather than listed and refusing — the brand masks' rule for
 * a surface that is not there.
 */

/** Opens the chat and sends `text` as the user's first message. */
export type ChatOpener = (text: string) => void;

let opener: ChatOpener | undefined;

/** The chat surface publishes its opener; `undefined` withdraws it. */
export function setChatOpener(next: ChatOpener | undefined): void {
  opener = next;
}

/** The opener, if a chat surface is mounted. */
export function chatOpener(): ChatOpener | undefined {
  return opener;
}
